<template>
  <div class="page-container">
    <div id="mainWrapper" class="POSWrapper">
    <Modal :isVisible="showModalTip" @close="showModalTip = false">
      <h2 class="tipModalTitle">Add tip address and amount</h2>
      <input
          v-model="tipAddress"
          class="inputThing3"
          placeholder="Tip lightning address"
      />
      <div class="multipleInputContainer">
        <input
            v-model="tipAmount"
            class="inputThing3Half"
            placeholder="Tip amount"
        />
        <select v-model="tipCurrency" class="inputThing2">
          <option default :value="fiat">{{ fiat }}</option>
          <option value="SATS">SATS</option>
          <option value="Percent">%</option>
        </select>
      </div>
      <div class="modalActionsRow">
        <button class="btn-secondary btn-secondary2" @click="showModalTip = false">Close</button>
        <button class="btn-secondary-alt" @click="showModalTip = false">Add</button>
      </div>
    </Modal>

    <Modal :isVisible="showModalOrder" @close="showModalOrder = false">
      <h2 class="tipModalTitle">Add OrderID</h2>
      <p class="tipCurrentBase">Enter an order ID to track this invoice more easily.</p>
      <input
          v-model="orderId"
          class="inputThing3"
          placeholder="OrderID"
      />
      <div class="modalActionsRow">
        <button class="btn-secondary btn-secondary2" @click="() => { showModalOrder = false; orderId = ''; }">Close</button>
        <button class="btn-secondary-alt" @click="showModalOrder = false">Add</button>
      </div>
    </Modal>

    <Modal :isVisible="showTipSelectModal" @close="showTipSelectModal = false">
      <div class="modalHeader tipModalHeader">
        <div class="tipModalHeaderContent">
          <h2 class="tipModalTitle">{{ $t('Add a tip?') }}</h2>
          <div class="tipCurrentBase">{{ $t('Current total') }}: <strong>{{ formatCurrency(totalAfterDiscount) }} {{ currency }}</strong></div>
        </div>
        <button class="closeBtn" @click="showTipSelectModal = false"><i class="fas fa-calculator"></i></button>
      </div>

      <!-- Tip Modes Selection -->
      <div v-if="data.settings?.tipSettings?.rounding" class="tipModeSelector">
        <button class="tipModeBtn" :class="{ 'tipModeBtn--active': tipMode === 'percent' }" @click="tipMode = 'percent'">{{ $t('Percentage') }}</button>
        <button class="tipModeBtn" :class="{ 'tipModeBtn--active': tipMode === 'round' }" @click="tipMode = 'round'">{{ $t('Round Up') }}</button>
      </div>

      <div v-if="tipMode === 'percent'">
        <div class="tipOptions" role="group">
          <button type="button" class="tipBtn" :class="{ 'tipBtn--active': selectedTipPercent===5 }" @click="selectedTipPercent=5; customTipAmount='';">5%</button>
          <button type="button" class="tipBtn" :class="{ 'tipBtn--active': selectedTipPercent===10 }" @click="selectedTipPercent=10; customTipAmount='';">10%</button>
          <button type="button" class="tipBtn" :class="{ 'tipBtn--active': selectedTipPercent===15 }" @click="selectedTipPercent=15; customTipAmount='';">15%</button>
          <button type="button" class="tipBtn" :class="{ 'tipBtn--active': selectedTipPercent===20 }" @click="selectedTipPercent=20; customTipAmount='';">20%</button>
        </div>
        <div class="customTipRow">
          <label class="customTipLabel">{{ $t('Tipping amount') }}</label>
          <div class="customTipInputGroup">
            <input v-model="customTipAmount" inputmode="decimal" class="customTipInput" placeholder="0.00" />
            <span class="customTipCurrency">{{ currency }}</span>
          </div>
        </div>
      </div>

      <div v-if="tipMode === 'round'">
        <p class="tipHelp">{{ $t('Choose a total to round up to:') }}</p>
        <div class="tipOptions">
          <button v-for="target in roundUpTargets" :key="target" type="button" class="tipBtn" :class="{ 'tipBtn--active': roundUpTarget===target && !customRoundUpTotal }" @click="roundUpTarget=target; customRoundUpTotal='';">
            {{ formatCurrency(target) }}
          </button>
        </div>
        <div class="customTipRow customTipRow--withHint">
          <label class="customTipLabel">{{ $t('Total amount') }}</label>
          <div class="customTipInputGroup">
            <input v-model="customRoundUpTotal" inputmode="decimal" class="customTipInput" placeholder="0.00" />
            <span class="customTipCurrency">{{ currency }}</span>
          </div>
          <div class="customTipHint">
            {{ $t('Minimum is') }} {{ formatCurrency(totalAfterDiscount) }} {{ currency }}
          </div>
        </div>
      </div>

      <div class="tipSummaryCard">
        <div class="tipSummaryRow">
          <span>{{ $t('Subtotal') }}</span>
          <span>{{ formatCurrency(grandTotal) }} {{ currency }}</span>
        </div>
        <div v-if="hasBitcoinDiscount" class="tipSummaryRow tipSummaryRow--discount">
          <span>{{ $t('Bitcoin Discount') }}</span>
          <span>-{{ formatCurrency(bitcoinDiscountAmount) }} {{ currency }}</span>
        </div>
        <div class="tipSummaryRow">
          <span>{{ $t('Tip') }}</span>
          <span>{{ formatCurrency(tipAmountComputed) }} {{ currency }}</span>
        </div>
        <div class="tipSummaryDivider"></div>
        <div class="tipSummaryRow tipSummaryRow--total">
          <span>{{ $t('Total') }}</span>
          <span>{{ formatCurrency(totalWithTipAndDiscountComputed) }} {{ currency }}</span>
        </div>
      </div>

      <div class="tipModalActions">
        <button class="tipConfirmBtn" :disabled="isCreatingInvoice" @click="confirmTipAndCharge">
          <i class="fas fa-bolt"></i>
          {{ $t('Pay Now') }}
        </button>
        <button class="tipSkipBtn" :disabled="isCreatingInvoice" @click="skipTipAndCharge">{{ $t('Pay without tip') }}</button>
      </div>
    </Modal>

    <Modal :isVisible="showPOSModal" @close="showPOSModal = false">
      <div class="modalHeader">
        <h2 class="modalTitle">Shop</h2>
        <button class="closeBtn" @click="showPOSModal = false"><i class="fas fa-calculator"></i></button>
      </div>

      <div class="posModalContent">
        <!-- Products Section -->
        <div class="productsView productsView--modal">
          <div v-for="group in groupedProducts" :key="group.name" class="productSection">
            <div class="modalDivider" v-if="group.isUncategorized && group.hasCategoriesAbove"></div>
            <div class="categoryHeader" v-if="group.name" @click="toggleCategory(group.name)">
              <div class="categoryHeaderLeft">
                <div v-if="group.icon" class="categoryIcon">
                  <img :src="getIconUrl(group.icon)" :alt="group.name" />
                </div>
                <h3 class="categoryTitle">{{ group.name }}</h3>
              </div>
              <i class="fas" :class="isCollapsed(group.name) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
            </div>
            <div class="productGrid" v-show="!group.name || !isCollapsed(group.name)">
              <div
                  v-for="p in group.products"
                  :key="p.sku"
                  :class="['productCard', { justAdded: highlightedSku===p.sku, inCart: isInCart(p.sku) }]"
                  @click="!isInCart(p.sku) && addToCart(p)"
                  @touchstart="isInCart(p.sku) && startLongPress(p.sku)"
                  @touchend="cancelLongPress"
                  @touchcancel="cancelLongPress"
              >
                <div class="productCardInner">
                  <div class="productInfo">
                    <div class="productName">{{ p.name }}</div>
                    <div class="productPrice">{{ p.price }} {{ fiat }}</div>
                  </div>
                  <div v-if="isInCart(p.sku)" class="productQtyControls" @click.stop>
                    <button class="productQtyBtn productQtyBtn--minus" @click="decQty(p)"><i class="fas fa-minus"></i></button>
                    <span class="productQtyBadge">{{ cartQty(p.sku) }}</span>
                    <button class="productQtyBtn productQtyBtn--plus" @click="addToCart(p)"><i class="fas fa-plus"></i></button>
                  </div>
                  <div v-else class="productAddHint"><i class="fas fa-plus"></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modalDivider" v-if="cart.length"></div>

        <!-- Cart Section (on bottom) -->
        <div class="cartSection cartSection--modal">
          <div v-if="cart.length" class="cartList">
            <div v-for="item in cart" :key="item.sku" class="cartItemWrapper"
                 @touchstart="onCartSwipeStart($event, item.sku)"
                 @touchmove="onCartSwipeMove($event, item.sku)"
                 @touchend="onCartSwipeEnd(item.sku)">
              <div class="cartItemDeleteBg"><i class="fas fa-trash"></i> Remove</div>
              <div class="cartItem" :style="cartSwipeStyle(item.sku)">
                <div class="cartItemLeft">
                  <div class="cartName">{{ item.name }}</div>
                  <div class="cartItemPrice">{{ formatCurrency(item.price * item.qty) }} {{ fiat }}</div>
                </div>
                <div class="cartItemRight">
                  <div class="qtyControls" v-if="item.sku !== keypadSku">
                    <button class="qtyBtn" @click="decQty(item)">−</button>
                    <div class="qtyBadge">{{ item.qty }}</div>
                    <button class="qtyBtn" @click="incQty(item)">+</button>
                  </div>
                  <div class="qtyControls" v-else>
                    <div class="qtyBadge">1</div>
                  </div>
                  <button class="removeBtn" @click="removeItem(item.sku)" aria-label="Remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <button class="linkBtn clearCart" @click="confirmClearCart()">Clear all items</button>
          </div>
          <div v-else class="emptyCart">
            <p>Your cart is empty</p>
          </div>
        </div>
      </div>

      <div class="modalActionsRow" v-if="cart.length">
        <button class="chargeBtn modalChargeBtn" :disabled="isCreatingInvoice" @click="showPOSModal = false; onChargeClick()">
          <i class="fas fa-bolt"></i>
          <span>Pay Now {{ formatCurrency(hasBitcoinDiscount ? totalAfterDiscount : grandTotal) }} {{ fiat }}</span>
        </button>
      </div>
    </Modal>

    <!-- Top bar -->
    <div class="posTopBar">
      <div class="posTopBar__side">
        <button
            class="posActionBtn"
            :class="{ 'posActionBtn--active': showDropdown }"
            @click="showDropdown = !showDropdown"
        >
          <i class="fas fa-plus-circle"></i>
          <span>Add</span>
        </button>
        <transition name="fade">
          <div v-if="showDropdown" class="drop">
            <div
                @click="
                  () => {
                    showDropdown = false;
                    showModalOrder = true;
                  }
                "
                class="dropItem"
            >
              OrderID
            </div>
          </div>
        </transition>
      </div>
      <div class="posTopBar__center">
        <img v-if="data.settings?.logo" :src="data.settings.logo" alt="Store Logo" class="storeLogo" />
      </div>
      <div class="posTopBar__side posTopBar__side--right">
        <button
            v-if="hasProducts"
            class="closeBtn posActionBtn--cart"
            @click="showPOSModal = true"
        >
          <div class="cartIconWrapper">
            <i class="fas fa-shopping-cart"></i>
            <span v-if="totalCartQty" class="cartBadge">{{ totalCartQty }}</span>
          </div>
        </button>
      </div>
    </div>

    <!-- Product added toast -->
    <transition name="toast-pop" :key="toastKey">
      <div v-if="showAddedToast" class="addedToast" @click="showAddedToast=false" role="status" aria-live="polite">
        <i class="fas fa-check-circle"></i>
        <span>Added {{ addedProductName }}</span>
      </div>
    </transition>

    <!-- Terminal info -->
    <div class="posInfo">
      <div v-if="data.posName" class="posName">{{ data.posName }}</div>
      <h4 v-if="data.settings?.terminalName" class="terminalName">{{ data.settings.terminalName }}</h4>
      <div class="orderIdBadge" v-if="orderId">{{ orderId }}</div>
      <div class="orderIdHint" v-else>Auto ID on charge</div>
    </div>

    <!-- Split totals for products vs keypad -->
    <div class="splitTotals" v-if="hasProducts && cart && cart.length">
      <div class="splitRow">
        <span>Products</span>
        <span>{{ formatCurrency(productSubtotal) }} {{ fiat }}</span>
      </div>
      <div class="splitRow">
        <span>Keypad</span>
        <span>{{ formatCurrency(keypadSubtotal) }} {{ fiat }}</span>
      </div>
      <div class="splitRow total">
        <span>Total</span>
        <span>{{ formatCurrency(grandTotal) }} {{ fiat }}</span>
      </div>
    </div>

    <!-- Bitcoin Discount Display -->
    <div v-if="hasBitcoinDiscount" class="discount-box">
      <div class="price-row">
        <span>{{ $t('Regular Price') }}:</span>
        <span class="strike-through">{{ formatCurrency(grandTotal) }} {{ fiat }}</span>
      </div>
      <div class="price-row discount text-success">
        <span>
          <svg class="discount-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
          </svg>
          {{ $t('Bitcoin Price') }} ({{ bitcoinDiscountValue }}{{ bitcoinDiscountType === 'percentage' ? '%' : '' }} {{ $t('Discount') }}):
        </span>
        <span class="fw-bold">{{ formatCurrency(totalAfterDiscount) }} {{ fiat }}</span>
      </div>
    </div>

    <!-- Keypad View (Amount section + Numpad) -->
    <div class="keypadView">
      <!-- Amount section -->
      <div class="amountSection">
        <div class="amountDisplay">
          <span class="amountVal">{{ inputVal }}</span>
          <span class="amountCur">{{ currency }}</span>
          <button @click="deleteNum" class="deleteBtn" aria-label="Delete last digit">
            <i class="fas fa-backspace"></i>
          </button>
        </div>
        <div class="convRow">
          <span class="convVal">≈ {{ convertedValue }}</span>
          <span class="convCur">{{ currency === "SATS" ? data.settings?.currency : "SATS" }}</span>
          <button @click="swapCurrency" class="swapBtn" aria-label="Swap currency">
            <i class="fas fa-exchange-alt"></i>
          </button>
        </div>
      </div>

      <!-- Numpad -->
      <div class="numpad">
        <div class="numpadRow">
          <div @click="addNum(1)" class="numKey">1</div>
          <div @click="addNum(2)" class="numKey">2</div>
          <div @click="addNum(3)" class="numKey">3</div>
        </div>
        <div class="numpadRow">
          <div @click="addNum(4)" class="numKey">4</div>
          <div @click="addNum(5)" class="numKey">5</div>
          <div @click="addNum(6)" class="numKey">6</div>
        </div>
        <div class="numpadRow">
          <div @click="addNum(7)" class="numKey">7</div>
          <div @click="addNum(8)" class="numKey">8</div>
          <div @click="addNum(9)" class="numKey">9</div>
        </div>
        <div class="numpadRow">
          <div @click="addNum(decSep)" class="numKey numKey--sep">{{ decSep }}</div>
          <div @click="addNum(0)" class="numKey">0</div>
          <div @click="clearInput" class="numKey numKey--clear">C</div>
        </div>
      </div>
    </div>

    <!-- Optional customer email input -->
    <div v-if="data?.settings?.collectCustomerEmail" class="emailInputWrapper">
      <input id="customerEmail" v-model="customerEmail" type="email" class="inputThing3"
             placeholder="customer@email.com"/>
    </div>

    <!-- Charge button -->
    <button @click="onChargeClick" class="chargeBtn" :disabled="isCreatingInvoice || grandTotal <= 0">
      <i class="fas fa-bolt"></i>
      <span>Pay Now</span>
      <span v-if="grandTotal > 0" class="chargeAmt">
        {{ formatCurrency(hasBitcoinDiscount ? totalAfterDiscount : grandTotal) }} {{ fiat }}
      </span>
    </button>

    <div class="posFooter">
      <img src="../assets/pbc.png" alt="pbc"/>
    </div>
  </div>
</div>
</template>

<script>
import Modal from "./Modal.vue";

export default {
  name: "POS",
  components: {
    Modal,
  },
  data() {
    return {
      decSep: ",",
      thousSep: ".",
      inputVal: `0,00`,
      cleanVal: "0",
      // Separate keypad input buffer to allow keypad as its own cart item
      keypadInputVal: `0,00`,
      keypadSku: 'KEYPAD',
      keypadName: 'Keypad amount',
      currency: "EUR",
      fiat: "EUR",
      data: {},
      orderId: "",
      rate: 1,
      showModalTip: false,
      showModalOrder: false,
      tipCurrency: "EUR",
      showDropdown: false,
      tipAddress: "",
      tipAmount: "",
      storeId: "",
      convertedValue: 0,
      posId: "",
      terminalId: "",
      posSlug: null,
      terminalSlug: null,
      // New fields for products and quantity
      products: [],
      selectedSku: "",
      quantity: 1,
      // Simple cart for multiple products
      cart: [],
      // Customer email collection
      customerEmail: "",
      // Toast for product added
      showAddedToast: false,
      addedProductName: "",
      toastKey: 0,
      addToastTimer: null,
      // Tipping modal state
      showTipSelectModal: false,
      selectedTipPercent: null,
      tipMode: 'percent', // 'percent' | 'round'
      roundUpTarget: null,
      highlightedSku: "",
      customTipAmount: '',
      activeView: 'keypad', // 'keypad' | 'products'
      showPOSModal: false,
      collapsedCategories: [],
      customRoundUpTotal: '',
      isCreatingInvoice: false,
      // Swipe-to-remove state
      swipeState: {},  // { [sku]: { startX, currentX } }
      longPressTimer: null,
    };
  },
  computed: {
    hasProducts() {
      return Array.isArray(this.products) && this.products.length > 0;
    },
    // Subtotals for products vs keypad
    productSubtotal() {
      if (!Array.isArray(this.cart) || this.cart.length === 0) return 0;
      return this.cart
          .filter(it => it.sku !== this.keypadSku)
          .reduce((sum, it) => sum + (Number(it.price) || 0) * (Number(it.qty) || 0), 0);
    },
    keypadSubtotal() {
      if (!Array.isArray(this.cart) || this.cart.length === 0) return 0;
      return this.cart
          .filter(it => it.sku === this.keypadSku)
          .reduce((sum, it) => sum + (Number(it.price) || 0) * (Number(it.qty) || 0), 0);
    },
    grandTotal() {
      return (Number(this.productSubtotal) || 0) + (Number(this.keypadSubtotal) || 0);
    },
    hasBitcoinDiscount() {
      return (this.data.settings?.bitcoinDiscount?.value > 0) && this.grandTotal > 0;
    },
    bitcoinDiscountType() {
      return this.data.settings?.bitcoinDiscount?.type || 'percentage';
    },
    bitcoinDiscountValue() {
      return this.data.settings?.bitcoinDiscount?.value || 0;
    },
    bitcoinDiscountAmount() {
      if (!this.hasBitcoinDiscount) return 0;
      const d = this.data.settings.bitcoinDiscount;
      if (d.type === 'percentage') {
        return this.grandTotal * (Number(d.value) / 100);
      } else {
        return Math.min(Number(d.value), this.grandTotal);
      }
    },
    totalAfterDiscount() {
      return Math.max(0, this.grandTotal - this.bitcoinDiscountAmount);
    },
    roundUpTargets() {
      const base = this.totalAfterDiscount;
      if (base <= 0) return [];
      // Use the total including default percentage tip as floor so round-up
      // targets are never below what the user saw on the percentage tab
      const defaultTipPercent = this.selectedTipPercent || 10;
      const floor = base * (1 + defaultTipPercent / 100);
      const targets = [];
      [1, 5, 10, 50, 100].forEach(step => {
        const t = Math.ceil(base / step) * step;
        if (t > base && t >= Math.ceil(floor) && !targets.includes(t)) targets.push(t);
      });
      // If all targets were filtered out, generate from floor instead
      if (targets.length === 0) {
        [1, 5, 10, 50, 100].forEach(step => {
          const t = Math.ceil(floor / step) * step;
          if (t >= Math.ceil(floor) && !targets.includes(t)) targets.push(t);
        });
      }
      return targets.sort((a,b) => a-b).slice(0, 3);
    },
    tipAmountComputed() {
      if (this.tipMode === 'round') {
        if (this.customRoundUpTotal) {
          const parsed = parseFloat(this.customRoundUpTotal.replace(',', '.'));
          return isNaN(parsed) ? 0 : Math.max(0, parsed - this.totalAfterDiscount);
        }
        if (this.roundUpTarget) {
          // Use the total AFTER discount as the base for rounding
          return Math.max(0, this.roundUpTarget - this.totalAfterDiscount);
        }
      }
      if (this.customTipAmount) {
        const parsed = parseFloat(this.customTipAmount.replace(',', '.'));
        return isNaN(parsed) ? 0 : parsed;
      }
      if (this.selectedTipPercent) {
        return this.totalAfterDiscount * (this.selectedTipPercent / 100);
      }
      return 0;
    },
    totalWithTipAndDiscountComputed() {
      return this.totalAfterDiscount + this.tipAmountComputed;
    },
    totalCartQty() {
      if (!Array.isArray(this.cart)) return 0;
      return this.cart.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
    },
    flattenedProducts() {
      if (!this.products) return [];
      return this.products;
    },
    groupedProducts() {
      if (!this.products) return [];
      const groups = [];
      const categories = this.data.settings?.categories || [];

      // Add categories with their products
      categories.forEach(cat => {
        const catProducts = this.products.filter(p => p.category === cat.name);
        if (catProducts.length > 0) {
          groups.push({
            name: cat.name,
            icon: cat.icon,
            products: catProducts,
            isUncategorized: false
          });
        }
      });

      // Add products without category
      const uncategorizedProducts = this.products.filter(p => !p.category || !categories.find(c => c.name === p.category));
      if (uncategorizedProducts.length > 0) {
        groups.push({
          name: '',
          icon: '',
          products: uncategorizedProducts,
          isUncategorized: true,
          hasCategoriesAbove: groups.length > 0
        });
      }

      return groups;
    },
  },
  watch: {
    inputVal(newVal) {
      if (newVal[newVal.length - 1] !== this.decSep) {
        this.convertedValue =
            this.currency === "SATS"
                ? (this.cleanVal * this.rate).toFixed(8)
                : Math.ceil((this.cleanVal * 1) / this.rate);
        this.convertedValue = this.convertedValue
            ?.toString()
            .replaceAll(".", ",");
        this.convertedValue = this.formatNum(this.convertedValue);
      }
    },
    selectedSku() {
      this.updateAmountFromSelection();
    },
    quantity() {
      this.updateAmountFromSelection();
    },
    // When cart changes, recompute subtotal and set amount
    cart: {
      deep: true,
      handler() {
        // Do not override the keypad input field; totals are shown separately in splitTotals
      },
    },
    // When user types a custom tip amount, clear preset selection and sanitize input
    customTipAmount(val) {
      if (val === null || val === undefined) return;
      let s = String(val);
      // Allow only digits and decimal separators
      s = s.replace(/[^0-9.,]/g, '');
      // Remove extra decimal separators beyond the first occurrence
      let seenSep = false;
      let out = '';
      for (const ch of s) {
        if (ch === '.' || ch === ',') {
          if (seenSep) continue;
          seenSep = true;
        }
        out += ch;
      }
      this.customTipAmount = out;
      if (this.customTipAmount !== '') {
        this.selectedTipPercent = null;
        this.roundUpTarget = null;
        this.customRoundUpTotal = '';
      }
    },
    // When user types a custom total amount, clear preset selection and sanitize input
    customRoundUpTotal(val) {
      if (val === null || val === undefined) return;
      let s = String(val);
      // Allow only digits and decimal separators
      s = s.replace(/[^0-9.,]/g, '');
      // Remove extra decimal separators beyond the first occurrence
      let seenSep = false;
      let out = '';
      for (const ch of s) {
        if (ch === '.' || ch === ',') {
          if (seenSep) continue;
          seenSep = true;
        }
        out += ch;
      }
      this.customRoundUpTotal = out;
      if (this.customRoundUpTotal !== '') {
        const parsed = parseFloat(this.customRoundUpTotal.replace(',', '.'));
        // If the parsed value is greater than zero but less than the total, clamp it to the total
        if (!isNaN(parsed) && parsed > 0 && parsed < this.totalAfterDiscount) {
          this.customRoundUpTotal = this.totalAfterDiscount.toFixed(2).replace('.', this.decSep);
        }
        this.selectedTipPercent = null;
        this.roundUpTarget = null;
        this.customTipAmount = '';
      }
    },
  },
  mounted() {
    this.getPosID();
    if (!this.terminalSlug) {
      this.inputVal = `0${this.decSep}00`;
      return;
    }
    this.loadPosData();
    window.addEventListener('pageshow', this.onPageShow);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeUnmount() {
    if (this.addToastTimer) {
      clearTimeout(this.addToastTimer);
      this.addToastTimer = null;
    }
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    // Restore the Pay Now button if the page was restored from bfcache
    // (back/forward navigation) — isCreatingInvoice was left true when
    // we redirected to the checkout page.
    onPageShow(e) {
      if (e.persisted) {
        this.isCreatingInvoice = false;
      }
    },
    // Same safety net for PWA minimize/resume on mobile.
    onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.isCreatingInvoice = false;
      }
    },
    toggleCategory(categoryName) {
      const idx = this.collapsedCategories.indexOf(categoryName);
      if (idx > -1) {
        this.collapsedCategories.splice(idx, 1);
      } else {
        this.collapsedCategories.push(categoryName);
      }
    },
    isCollapsed(categoryName) {
      return this.collapsedCategories.includes(categoryName);
    },
    getIconUrl(icon) {
      if (!icon) return '';
      const [prefix, name] = icon.split(':');
      return `https://api.iconify.design/${prefix}/${name}.svg`;
    },
    // Return selected product object by SKU
    getSelectedProduct() {
      if (!this.selectedSku) return null;
      return this.products.find((p) => p.sku === this.selectedSku) || null;
    },

    // Check if a product is currently in the cart (qty > 0)
    isInCart(sku) {
      if (!sku) return false;
      const found = this.cart.find((i) => i.sku === sku);
      return !!(found && Number(found.qty) > 0);
    },

    // Get quantity in cart for a product SKU (0 if not in cart)
    cartQty(sku) {
      const found = this.cart.find((i) => i.sku === sku);
      return found ? Number(found.qty) : 0;
    },

    // Format a number into inputVal according to current fiat decimal separator
    setInputFromNumber(n) {
      // Always set the base amount in fiat with two decimals
      const fixed = Number.isFinite(n) ? n.toFixed(2) : "0.00";
      const withSep = this.decSep === "," ? fixed.replace(".", ",") : fixed;
      this.inputVal = this.formatNum(withSep);
    },

    // Update amount when product or quantity changes
    updateAmountFromSelection() {
      const prod = this.getSelectedProduct();
      if (!prod || !this.quantity || this.quantity <= 0) return;
      const total = (Number(prod.price) || 0) * Number(this.quantity);
      this.setInputFromNumber(total);
    },

    // CART helpers
    addToCart(product) {
      if (!product) return;
      const idx = this.cart.findIndex((i) => i.sku === product.sku);
      if (idx >= 0) {
        this.cart[idx].qty += 1;
      } else {
        this.cart.push({sku: product.sku, name: product.name, price: Number(product.price) || 0, qty: 1});
      }
      // Trigger product added toast/animation
      this.addedProductName = product.name || "Product";
      // Immediately hide previous toast if visible
      this.showAddedToast = false;
      // Clear previous timer
      if (this.addToastTimer) {
        clearTimeout(this.addToastTimer);
        this.addToastTimer = null;
      }
      // Bump key to restart transition, then show
      this.toastKey++;
      this.$nextTick(() => {
        this.showAddedToast = true;
        this.addToastTimer = setTimeout(() => {
          this.showAddedToast = false;
          this.addToastTimer = null;
        }, 1000);
      });
    },
    incQty(item) {
      if (!item) return;
      const idx = this.cart.findIndex((i) => i.sku === item.sku);
      if (idx >= 0) this.cart[idx].qty += 1;
    },
    decQty(item) {
      if (!item) return;
      const idx = this.cart.findIndex((i) => i.sku === item.sku);
      if (idx >= 0) {
        const newQty = Math.max(0, (this.cart[idx].qty || 0) - 1);
        if (newQty === 0) {
          this.cart.splice(idx, 1);
        } else {
          this.cart[idx].qty = newQty;
        }
      }
    },
    removeItem(sku) {
      const idx = this.cart.findIndex((i) => i.sku === sku);
      if (idx >= 0) this.cart.splice(idx, 1);
      if (sku === this.keypadSku) {
        this.keypadInputVal = `0${this.decSep}00`;
        this.inputVal = this.keypadInputVal;
      }
    },
    clearCart() {
      this.cart = [];
      this.keypadInputVal = `0${this.decSep}00`;
      // keep inputThing showing keypad amount only
      this.inputVal = this.keypadInputVal;
    },
    confirmClearCart() {
      if (confirm('Remove all items from cart?')) {
        this.clearCart();
      }
    },
    onCartSwipeStart(e, sku) {
      const touch = e.touches[0];
      this.swipeState = { ...this.swipeState, [sku]: { startX: touch.clientX, currentX: touch.clientX } };
    },
    onCartSwipeMove(e, sku) {
      const s = this.swipeState[sku];
      if (!s) return;
      const touch = e.touches[0];
      const dx = touch.clientX - s.startX;
      // Only allow swiping left
      this.swipeState = { ...this.swipeState, [sku]: { ...s, currentX: touch.clientX, dx: Math.min(0, dx) } };
    },
    onCartSwipeEnd(sku) {
      const s = this.swipeState[sku];
      if (!s) return;
      const threshold = -80;
      if (s.dx !== undefined && s.dx < threshold) {
        this.removeItem(sku);
      }
      const copy = { ...this.swipeState };
      delete copy[sku];
      this.swipeState = copy;
    },
    cartSwipeStyle(sku) {
      const s = this.swipeState[sku];
      if (!s || !s.dx) return {};
      return { transform: `translateX(${s.dx}px)`, transition: 'none' };
    },
    startLongPress(sku) {
      this.cancelLongPress();
      this.longPressTimer = setTimeout(() => {
        if (confirm(`Remove "${this.cart.find(i => i.sku === sku)?.name}" from cart?`)) {
          this.removeItem(sku);
        }
      }, 500);
    },
    cancelLongPress() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },
    buildCartDescription() {
      if (!this.cart || !this.cart.length) return undefined;
      const parts = this.cart.map((i) => `${i.name} x${i.qty} (${i.sku})`);
      return parts.join(", ");
    },

    // Build metadata to attach to the transaction
    buildMetadata() {
      const items = [];
      if (this.cart && this.cart.length) {
        for (const it of this.cart) {
          // Exclude keypad/custom amount from products metadata
          if (it.sku === this.keypadSku || it.source === 'keypad') continue;
          const item = {
            sku: it.sku,
            name: it.name,
            price: Number(it.price) || 0,
            qty: Number(it.qty) || 0,
            currency: this.fiat
          };
          items.push(item);
        }
      } else {
        const sel = this.getSelectedProduct?.();
        if (sel) {
          items.push({
            sku: sel.sku,
            name: sel.name,
            price: Number(sel.price) || 0,
            qty: Number(this.quantity) || 1,
            currency: this.fiat
          });
        }
      }
      // Keep only products in metadata, and only if products are present
      const meta = {};
      if (items.length) {
        meta.products = items;
      }
      return meta;
    },

    getPosID() {
      try {
        const route = this.$route
        if (route.params.posSlug && route.params.terminalSlug) {
          this.posSlug = route.params.posSlug
          this.terminalSlug = route.params.terminalSlug
        } else if (route.params.terminalSlug) {
          this.posSlug = null
          this.terminalSlug = route.params.terminalSlug
        } else {
          window.location.href = 'https://coinsnap.io'
          return
        }
      } catch {
        window.location.href = 'https://coinsnap.io'
      }
    },

    async loadPosData() {
      try {
        let url
        if (this.posSlug) {
          url = `/api/apps/pos/${this.posSlug}/${this.terminalSlug}`
        } else {
          url = `/api/apps/pos/${this.terminalSlug}`
        }
        const res = await this.$store.dispatch('getApiCallAction', { hook: url })
        if (!res || res.error) {
          console.error('Failed to load POS data')
          return
        }
        this.processPosData(res)
        await this.loadStoreRates(res.storeId)
        this.inputVal = `0${this.decSep}00`
      } catch (e) {
        console.error('Error loading POS data:', e)
      }
    },

    processPosData(data) {
      const decodedName = document.createElement("textarea");

      // Ensure settings is an object (API may return it as a JSON string)
      let settings = data.settings;
      if (typeof settings === "string") {
        try {
          settings = JSON.parse(settings);
        } catch (e) {
          console.warn("Failed to parse settings JSON. Using empty object.", e);
          settings = {};
        }
      }

      // Keep parsed settings on data
      const safeData = {...data, settings};

      decodedName.innerHTML = safeData.name ?? "";

      this.data = {
        ...safeData,
        name: decodedName.value,
      };

      this.currency = safeData.settings?.currency || "EUR"; // default fallback
      this.fiat = this.currency;
      this.storeId = safeData.storeId;

      // Initialize products and default selection
      this.products = Array.isArray(safeData.settings?.products)
          ? safeData.settings.products
          : [];


      if (this.products.length > 0) {
        // Do not auto-select the first product on initial load.
        // Leave selection empty so the amount remains 0 until user interaction.
        this.selectedSku = "";
        this.quantity = 1;
        // Default to products view if products are configured
        this.activeView = 'products';
        // Open the products modal by default if there are products
        this.showPOSModal = true;
        // Intentionally NOT calling updateAmountFromSelection here.
      }
    },

    async loadStoreRates(storeId) {
      try {
        const ratesResponse = await this.$store.dispatch("getApiCallAction", {
          hook: `/api/internal/stores/${storeId}/rates`,
        });

        if (ratesResponse && Array.isArray(ratesResponse)) {
          const satsRate = ratesResponse.find(
              (rate) => rate.currencyPair === `SATS_${this.currency}`
          );
          this.rate = satsRate ? satsRate.rate : 0.2123; // default fallback
        } else {
          this.rate = 0.2123; // default fallback
        }
      } catch (error) {
        console.error("Error loading store rates:", error);
        this.rate = 0.2123; // default fallback
      }
    },

    swapCurrency() {
      if (this.currency === this.fiat) {
        this.currency = "SATS";
        this.inputVal = this.inputVal.toString().replaceAll(this.decSep, "");
        if (this.inputVal === "000") {
          this.inputVal = `0${this.decSep}00`;
        }
      } else {
        this.currency = this.fiat;
      }
      this.cleanVal =
          this.decSep === "." ? this.inputVal : this.inputVal.replace(",", ".");
      this.convertedValue =
          this.currency === "SATS"
              ? (this.cleanVal * this.rate).toFixed(8)
              : Math.ceil((this.cleanVal * 1) / this.rate);
      this.convertedValue = this.convertedValue
          ?.toString()
          .replaceAll(".", ",");
      this.convertedValue = this.formatNum(this.convertedValue);
      const oldVal = this.inputVal;
      this.inputVal = `${this.inputVal}0`;
      this.inputVal = oldVal;
    },

    formatNum(num) {
      num = num.toString()?.replaceAll(this.thousSep, "");
      this.cleanVal =
          this.decSep === "." ? num : num?.toString().replace(",", ".");
      const numberSections = num?.split(this.decSep);
      const mainNumber = numberSections[0];
      const decimalPart = numberSections[1];
      const formattedNumber = parseInt(mainNumber, 10).toLocaleString("en-DE");
      return `${formattedNumber}${
          decimalPart ? `${this.decSep}${decimalPart}` : ""
      }`;
    },

    // Parse a localized number string according to current decSep
    parseLocalizedNumber(str) {
      if (str == null) return 0;
      const s = this.decSep === "." ? String(str) : String(str).replace(/\./g, "").replace(",", ".");
      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    },

    // Get keypad amount as a number
    getKeypadAmountNumber() {
      return this.parseLocalizedNumber(this.keypadInputVal);
    },

    // Ensure/update keypad cart item based on keypad buffer
    syncKeypadCartItem() {
      const amount = this.getKeypadAmountNumber();
      const idx = this.cart.findIndex((i) => i.sku === this.keypadSku);
      if (amount <= 0) {
        if (idx >= 0) this.cart.splice(idx, 1);
        return;
      }
      if (idx >= 0) {
        this.cart[idx].price = Number(amount);
        this.cart[idx].qty = 1;
        this.cart[idx].name = this.keypadName;
        this.cart[idx].source = 'keypad';
      } else {
        this.cart.push({ sku: this.keypadSku, name: this.keypadName, price: Number(amount), qty: 1, source: 'keypad' });
      }
    },

    // Recompute and display total from cart (including keypad item)
    updateTotalFromCartAndKeypad() {
      const total = this.cart && this.cart.length
          ? this.cart.reduce((sum, it) => sum + (Number(it.price) || 0) * (Number(it.qty) || 0), 0)
          : 0;
      this.setInputFromNumber(total);
    },

    addNum(num) {
      // Edit keypad buffer without clearing cart; keep keypad as separate item
      let buf = this.keypadInputVal;
      if (buf === `0${this.decSep}00`) {
        if (num === this.decSep) {
          buf = `0${num}`;
        } else if (num === 0) {
          buf = '0';
        } else {
          buf = num.toString();
        }
      } else {
        if (num === this.decSep && buf.includes(this.decSep)) {
          return;
        }
        if (num === this.decSep && this.currency === "SATS") {
          return;
        }
        if (buf.length > 9) {
          return;
        }
        if (num !== this.decSep) {
          buf += num.toString();
          buf = this.formatNum(buf);
        } else {
          buf += num.toString();
        }
      }
      this.keypadInputVal = buf;
      // Sync keypad item in cart
      this.syncKeypadCartItem();
      // Keep inputThing showing keypad amount only
      this.inputVal = this.keypadInputVal;
    },

    clearInput() {
      // Reset keypad buffer and remove keypad item only
      this.keypadInputVal = `0${this.decSep}00`;
      const idx = this.cart.findIndex((i) => i.sku === this.keypadSku);
      if (idx >= 0) this.cart.splice(idx, 1);
      this.inputVal = this.keypadInputVal;
      this.cleanVal = "0";
    },

    deleteNum() {
      // Backspace on keypad buffer only
      if (this.keypadInputVal !== `0${this.decSep}00`) {
        this.keypadInputVal = this.keypadInputVal?.slice(0, -1);
        this.keypadInputVal = this.formatNum(this.keypadInputVal);
      }
      if (this.keypadInputVal === "NaN" || !this.keypadInputVal || this.keypadInputVal === "") {
        this.keypadInputVal = `0${this.decSep}00`;
      }
      // Sync keypad item and totals
      this.syncKeypadCartItem();
      this.inputVal = this.keypadInputVal;
    },

    formatCurrency(n) {
      const num = Number(n || 0);
      const fixed = isNaN(num) ? 0 : num;
      const parts = fixed.toFixed(2).split(".");
      if (this.decSep === ",") {
        const intPart = Number(parts[0]).toLocaleString("en-DE");
        return `${intPart},${parts[1]}`;
      } else {
        const intPart = Number(parts[0]).toLocaleString("en-US");
        return `${intPart}.${parts[1]}`;
      }
    },

    isValidEmail(email) {
      // Simple, conservative email validation per RFC 5322 practical subset
      // Allows letters, digits, common symbols before @, and requires a dot in the domain
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    },

    // Handle Charge click with optional tipping step
    onChargeClick() {
      const enableTipping = !!this.data?.settings?.tipSettings?.enabled;
      if (enableTipping) {
        this.selectedTipPercent = 10; // sensible default
        this.customTipAmount = "";
        this.tipMode = 'percent';
        this.roundUpTarget = null;
        this.showTipSelectModal = true;
      } else {
        this.getQR();
      }
    },

    // Compute the current numeric amount from inputVal based on decSep
    computeCurrentAmountNumber() {
      const str = this.decSep === "." ? this.inputVal : this.inputVal.replace(/\./g, "").replace(",", ".");
      const n = parseFloat(str);
      return isNaN(n) ? 0 : n;
    },

    // Read selected tip percent from preset or custom field
    getSelectedTipPercent() {
      if (this.customTipAmount) {
        return 0; // custom amount is not percentage-based for calculation here
      }
      const p = parseFloat(this.selectedTipPercent);
      return !isNaN(p) && p >= 0 ? p : 0;
    },

    // Confirm and proceed with tip applied
    confirmTipAndCharge() {
      const tipAmount = this.tipAmountComputed;
      const adjusted = this.totalAfterDiscount + tipAmount;
      const isPercentTip = this.tipMode === 'percent' && !this.customTipAmount;
      const tipMeta = {
        currency: this.currency,
        mode: this.tipMode === 'round' ? 'round' : (this.customTipAmount ? 'custom' : 'percent'),
        ...(isPercentTip ? { percent: this.selectedTipPercent } : { amount: tipAmount }),
      };
      this.getQR(adjusted, tipMeta);
    },

    // Skip tipping and proceed
    skipTipAndCharge() {
      this.getQR();
    },

    getQR(adjustedAmount = null, tipMeta = null) {
      if (this.isCreatingInvoice) return;
      if (this.storeId === "") return;
      this.isCreatingInvoice = true;
      // Validate optional customer email if present and collection enabled
      if (this.data?.settings?.collectCustomerEmail && this.customerEmail) {
        const trimmed = this.customerEmail.trim();
        this.customerEmail = trimmed; // keep UI in sync
        if (!this.isValidEmail(trimmed)) {
          alert('Please enter a valid email address (e.g. name@example.com).');
          this.isCreatingInvoice = false;
          return;
        }
      }

      // Final amount to pay
      let finalAmount = adjustedAmount !== null && !isNaN(adjustedAmount)
          ? Number(adjustedAmount)
          : (this.hasBitcoinDiscount ? this.totalAfterDiscount : Number(this.grandTotal));

      // Auto-generate Order ID in format: POS-<5 random letters>-<YYYYMMDDHHmmss>
      if (!this.orderId || this.orderId.trim() === "") {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        const letters = Array.from({length: 5}, () => String.fromCharCode(65 + Math.floor(Math.random() * 26))).join("");
        this.orderId = `POS-${letters}-${timestamp}`;
      }

      const metadata = this.buildMetadata();
      if (this.hasBitcoinDiscount) {
        metadata.bitcoinDiscount = {
          applied: true,
          amount: this.bitcoinDiscountAmount,
          type: this.data.settings.bitcoinDiscount.type,
          value: this.data.settings.bitcoinDiscount.value
        };
      }
      // Tip must be moved out of metadata; handled at top-level payload
      if (tipMeta) {
        // no-op here, see payload.tip below
      }

      // Build invoice payload.
      // Sent without an API key: the backend's posProxyMiddleware lends the store's key only
      // when this page's origin is on its allow-list and terminalId belongs to the store.
      // A redirectUrl survives only if the merchant configured it or it points back to this page.
      const payload = {
        amount: finalAmount,
        currency: this.currency,
        orderId: this.orderId,
        referralCode: "D24OUU",
        terminalId: this.data?.id,
        metadata: metadata,
      };

      // Put keypad info into metadata: include only if keypad/custom amount is present
      const keypadItem = (this.cart || []).find(i => i && (i.sku === this.keypadSku || i.source === 'keypad'));
      if (keypadItem && Number(keypadItem.price) > 0) {
        const total = (Number(keypadItem.price) || 0) * (Number(keypadItem.qty) || 1);
        metadata.keypad = { present: true, total, currency: this.fiat };
      }

      // Move tip out of metadata into top-level payload
      if (tipMeta) {
        payload.tip = tipMeta;
      }

      // Add buyerEmail at top-level if email collection is enabled and provided
      if (this.data?.settings?.collectCustomerEmail && this.customerEmail) {
        payload.buyerEmail = this.customerEmail;
      }
      // Only include redirectUrl if provided in settings (non-empty)
      const ru = this.data?.settings?.redirectUrl;
      if (ru && typeof ru === "string" && ru.trim() !== "") {
        payload.redirectUrl = ru.trim();
      }
      // If autoRedirect is enabled in settings, pass redirectAutomatically to the invoice payload
      const autoForPayload = !!this.data?.settings?.autoRedirect;
      if (autoForPayload) {
        payload.redirectAutomatically = true;
        // If no custom redirectUrl is provided, default to current terminal page
        if (!payload.redirectUrl) {
          payload.redirectUrl = window.location.origin + window.location.pathname;
        }
      }

      this.$store
          .dispatch("postApiCallAction", {
            hook: `/api/v1/stores/${this.storeId}/invoices`,
            body: payload,
            json: true,
          })
          .then((res) => {
            if (!res?.checkoutLink) {
              this.isCreatingInvoice = false;
              return;
            }

            if (res?.id) {
              window.location.href = res.checkoutLink;
            }
          })
          .catch(() => {
            this.isCreatingInvoice = false;
          });
    },
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

@media (max-width: 440px) {
  .page-container {
    padding: 0;
    background-color: white;
    display: block; /* Stack content normally for scrolling */
  }
}

.POSWrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 420px;
  max-width: 100%;
  background-color: #fff;
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 16px 0 24px;
  margin: 20px auto; /* Center on desktop */
  gap: 14px;
  transition: all 0.2s ease-in-out;
}

@media (max-width: 440px) {
  .POSWrapper {
    justify-content: flex-start; /* Start from top to scroll down */
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    border-radius: 0;
    border: none;
    box-shadow: none;
    margin: 0;
  }
  .posActionBtn {
    font-size: 15px;
    padding: 8px 16px;
  }
  .keypadKey {
    font-size: 32px;
    padding: 20px;
  }
  .numKey {
    height: 70px;
    font-size: 32px;
  }
  .chargeBtn {
    font-size: 24px;
    padding: 22px;
  }
  .amountVal {
    font-size: 56px;
  }
  .amountCur {
    font-size: 24px;
  }
  .deleteBtn {
    font-size: 24px;
  }
  .viewToggle {
    gap: 16px;
    padding: 0 16px;
  }
  .toggleBtn {
    height: 60px;
    font-size: 18px;
  }
  .toggleBtn i {
    font-size: 24px;
  }
  .payBtn {
    font-size: 22px;
    padding: 18px;
  }
  .tipBtn {
    font-size: 19px;
    padding: 14px 16px;
  }
  .tipConfirmBtn {
    font-size: 19px;
    padding: 16px;
  }
  .keypadInput {
    font-size: 60px !important;
  }
  .dropItem {
    font-size: 15px;
    padding: 12px 16px;
  }
}

/* ── Top bar ── */
.posTopBar {
  display: flex;
  align-items: center;
  width: 92%;
  gap: 8px;
}
.posTopBar__side {
  flex: 1;
  display: flex;
  position: relative;
}
.posTopBar__side--right {
  justify-content: flex-end;
}
.posTopBar__center {
  flex: 1;
  display: flex;
  justify-content: center;
}
.posActionBtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  background: #fff;
  font-size: 15px;
  font-weight: 600;
  color: #444;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: background 0.15s, box-shadow 0.15s;
}
.posActionBtn:hover {
  background: #f3f4f6;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.posActionBtn--active {
  background: #f3f4f6;
  border-radius: 20px 20px 0 0;
}
.storeLogo {
  max-height: 36px;
  max-width: 120px;
  object-fit: contain;
}

/* ── Dropdown ── */
.drop {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-top: none;
  border-radius: 0 0 12px 12px;
  min-width: 110px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.dropItem {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: background 0.12s;
}
.dropItem:hover {
  background: #f3f4f6;
}

/* ── Terminal info ── */
.posInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.posName {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #9ca3af;
}
.terminalName {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin: 0;
  letter-spacing: -0.2px;
}
.orderIdBadge {
  padding: 3px 12px;
  background: #eef4ff;
  color: #3b6bb5;
  border: 1px solid rgba(91, 151, 211, 0.3);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.orderIdHint {
  font-size: 11px;
  color: #9ca3af;
}

/* ── View Toggle ── */
.posActionBtn--cart {
  background: #f3f4f6;
  border-color: transparent;
  width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.posActionBtn--cart .cartIconWrapper {
  margin: 0;
  position: relative;
}

.posActionBtn--cart i {
  font-size: 20px;
  color: #6b7280;
}

.posActionBtn--cart .cartBadge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff9900;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #fff;
}

.viewToggle {
  display: flex;
  width: 92%;
  gap: 12px;
}
.toggleBtn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 48px;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  color: #4b5563;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
}
.toggleBtn i {
  font-size: 18px;
}
.toggleBtn--active {
  background: #3d7dbf;
  color: #fff;
  border-color: #3d7dbf;
  box-shadow: 0 4px 12px rgba(61, 125, 191, 0.25);
}
.toggleBtn--has-items {
  border-color: #3d7dbf;
  color: #3d7dbf;
}

.cartIconWrapper {
  position: relative;
}
.cartBadge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}

.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.modalTitle {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #111827;
}
.closeBtn {
  background: #f3f4f6;
  border: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
}
.emptyCart {
  padding: 40px 0;
  text-align: center;
  color: #9ca3af;
}
.modalChargeBtn {
  width: 100% !important;
  margin-top: 8px;
}

.productsView, .keypadView {
  width: 92%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.productsView {
  width: 100%;
}
.productsView::-webkit-scrollbar {
  width: 4px;
}
.productsView::-webkit-scrollbar-track {
  background: transparent;
}
.productsView::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.categoryTitle {
  font-size: 14px;
  font-weight: 700;
  color: #374151;
  margin-top: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ── Amount section ── */
.amountSection {
  width: 100%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 18px;
  padding: 12px 18px 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.amountDisplay {
  display: flex;
  align-items: baseline;
  gap: 8px;
  position: relative;
  padding-right: 42px;
}
.amountVal {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -1px;
  line-height: 1;
}
.amountCur {
  font-size: 20px;
  font-weight: 600;
  color: #9ca3af;
}
.deleteBtn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 18px;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  line-height: 1;
  transition: color 0.15s, background 0.15s;
}
.deleteBtn:hover {
  color: #4b5563;
  background: rgba(0, 0, 0, 0.05);
}
.convRow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}
.convVal {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}
.convCur {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 500;
}
.swapBtn {
  margin-left: auto;
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #6b7280;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  transition: background 0.15s, color 0.15s;
}
.swapBtn:hover {
  background: #e5e7eb;
  color: #374151;
}

/* ── Split totals ── */
.splitTotals {
  width: 92%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 8px 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.splitTotals .splitRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #555;
  padding: 3px 0;
}
.splitTotals .splitRow.total {
  font-weight: 700;
  color: #111827;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  margin-top: 5px;
  padding-top: 6px;
  font-size: 16px;
}

/* ── Numpad ── */
.numpad {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.numpadRow {
  display: flex;
  gap: 8px;
}
.numKey {
  flex: 1;
  user-select: none;
  cursor: pointer;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
  color: #1f2937;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: transform 0.08s ease, background 0.12s ease, box-shadow 0.12s ease;
}
.numKey:hover {
  background: #f3f4f6;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}
.numKey:active {
  transform: scale(0.95);
  background: #e9eaec;
  box-shadow: none;
}
.numKey--sep {
  color: #6b7280;
  font-size: 20px;
}
.numKey--clear {
  background: linear-gradient(180deg, #ff9f1a, #ff8a00);
  color: #fff;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.3);
}
.numKey--clear:hover {
  filter: brightness(0.97);
  box-shadow: 0 6px 16px rgba(255, 140, 0, 0.4);
}
.numKey--clear:active {
  background: linear-gradient(180deg, #ff9f1a, #ff8a00);
  transform: scale(0.95);
}

/* ── Charge button ── */
.chargeBtn {
  width: 92%;
  padding: 16px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #5b97d3 0%, #3d7dbf 100%);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 6px 20px rgba(62, 125, 191, 0.4);
  transition: filter 0.15s ease, box-shadow 0.15s ease, transform 0.08s ease;
  letter-spacing: -0.2px;
}
.chargeBtn:hover {
  filter: brightness(1.06);
  box-shadow: 0 8px 26px rgba(62, 125, 191, 0.5);
}
.chargeBtn:active {
  transform: scale(0.99);
  filter: brightness(0.97);
}
.chargeBtn:disabled {
  background: #d1d5db;
  box-shadow: none;
  cursor: not-allowed;
  filter: none;
}
.chargeBtn:disabled:hover {
  filter: none;
  box-shadow: none;
}
.chargeBtn:disabled:active {
  transform: none;
}
.chargeAmt {
  font-size: 15px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 10px;
  border-radius: 20px;
}

/* ── Email input ── */
.emailInputWrapper {
  width: 92%;
}

/* ── Footer ── */
.posFooter {
  height: 22px;
  opacity: 0.35;
  display: flex;
  align-items: center;
}

img {
  max-width: 100%;
  max-height: 100%;
}

/* ── Discount box ── */
.discount-box {
  width: 92%;
  background-color: #f8fff9;
  border: 1px solid #d1e7dd;
  border-radius: 12px;
  padding: 12px;
}
.price-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 4px;
}
.price-row.discount {
  font-size: 16px;
  margin-top: 8px;
  border-top: 1px dashed #d1e7dd;
  padding-top: 8px;
}
.strike-through {
  text-decoration: line-through;
  color: #6c757d;
}
.discount-icon {
  margin-right: 4px;
  vertical-align: middle;
}
.fw-bold { font-weight: 700; font-size: 1.1em; }
.text-success { color: #22a045 !important; }
.text-muted { color: #6c757d !important; }

/* ── Modal shared input styles ── */
.inputThing2 {
  height: 52px;
  width: 100%;
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  background-color: #f7f7f8;
  font-size: 16px;
  font-weight: 600;
  padding: 0 12px;
}
.inputThing3 {
  min-height: 46px;
  padding: 10px 14px;
  width: 100%;
  text-align: center;
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background-color: #f7f7f8;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, background 0.15s;
}
.inputThing3:focus {
  border-color: rgba(91, 151, 211, 0.5);
  background: #fff;
}
.inputThing3Half {
  min-height: 46px;
  padding: 10px;
  width: 220px;
  text-align: center;
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background-color: #f7f7f8;
  font-size: 16px;
  font-weight: 600;
  outline: none;
}
.multipleInputContainer {
  width: 100%;
  display: flex;
  gap: 8px;
}

/* ── Modal action buttons ── */
.btn-secondary {
  padding: 10px 20px;
  background: linear-gradient(180deg, #6aa3d8, #518bc3);
  color: #fff;
  border: none;
  font-size: 15px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(100, 152, 208, 0.3);
  transition: filter 0.15s, box-shadow 0.15s;
}
.btn-secondary:hover {
  filter: brightness(1.05);
  box-shadow: 0 6px 16px rgba(100, 152, 208, 0.4);
}
.btn-secondary2:hover {
  filter: brightness(0.97);
}
.btn-secondary-alt {
  padding: 10px 20px;
  background: linear-gradient(180deg, #ff9f1a, #ff8a00);
  border: none;
  font-size: 15px;
  font-weight: 700;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 153, 0, 0.3);
  transition: filter 0.15s, box-shadow 0.15s;
}
.btn-secondary-alt:hover {
  filter: brightness(1.05);
  box-shadow: 0 6px 16px rgba(255, 153, 0, 0.4);
}

/* ── POS modal (Merged Products & Cart) ── */
.posModalContent {
  max-height: 80vh; /* Increased slightly for better mobile use */
  overflow-y: auto;
  padding: 4px;
}

.modalDivider {
  height: 1px;
  background: #f3f4f6;
  margin: 16px 0;
}

.cartSection--modal {
  margin-top: 0;
  background: #fff;
  border: none;
  padding: 0;
}

.productsView--modal {
  padding: 0;
}

.categoryHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 4px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
  border-radius: 8px;
}

.categoryHeader:hover {
  background: #f9fafb;
}

.categoryHeaderLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}

.categoryHeader i {
  color: #9ca3af;
  font-size: 14px;
  transition: transform 0.2s;
}

/* ── Products modal ── */
.productsModalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modalTitle {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.productsModalBody {
  max-height: 65vh;
  overflow: auto;
  width: 100%;
}
.productsModalFooter {
  display: flex;
  justify-content: flex-end;
}
.productSection {
  width: 100%;
  padding-bottom: 10px;
}
.productGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}
.categoryHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f3f4f6;
}
.categoryIcon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.categoryIcon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.categoryTitle {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}
.productCard {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.productCard:not(.inCart):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #ff9900;
  transform: translateY(-2px);
}
.productCard:not(.inCart):active {
  transform: scale(0.98) translateY(0);
}
.productCard.inCart {
  cursor: default;
}
.productCardInner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
.productInfo {
  flex: 1;
  text-align: left;
  min-width: 0;
}
.productName {
  font-weight: 700;
  font-size: 16px;
  color: #111827;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}
.productPrice {
  color: #ff9900;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.2;
}
.productAddHint {
  background: #f3f4f6;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b5563;
  font-size: 12px;
  transition: all 0.2s;
}
.productCard:hover .productAddHint {
  background: #ff9900;
  color: #fff;
}
.productQtyControls {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.productQtyBtn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  padding: 0;
}
.productQtyBtn--minus {
  background: #fee2e2;
  color: #dc2626;
}
.productQtyBtn--minus:hover {
  background: #dc2626;
  color: #fff;
}
.productQtyBtn--plus {
  background: #f3f4f6;
  color: #4b5563;
}
.productQtyBtn--plus:hover {
  background: #ff9900;
  color: #fff;
}
.productQtyBadge {
  font-weight: 700;
  font-size: 13px;
  color: #111827;
  min-width: 18px;
  text-align: center;
}
.cartSection {
  margin-top: 12px;
  background: #f8f9fb;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 14px;
  padding: 0 10px;
  overflow: hidden;
}
.cartHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 2px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.cartHeaderLabel {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6b7280;
}
.linkBtn {
  background: none;
  border: none;
  color: #5b97d3;
  text-decoration: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}
.linkBtn:hover { color: #3d7dbf; }
.cartList { display: flex; flex-direction: column; }
.cartItemWrapper {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.cartItemWrapper:last-child {
  border-bottom: none;
}
.cartItemDeleteBg {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 90px;
  background: #ef4444;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 0 8px 8px 0;
}
.cartItem {
  position: relative;
  background: #f8f9fb;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 2px;
}
.cartItemLeft {
  flex: 1;
  min-width: 0;
}
.cartName {
  font-weight: 600;
  font-size: 15px;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cartItemPrice {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  margin-top: 1px;
}
.cartItemRight {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.qtyControls { display: flex; align-items: center; gap: 4px; }
.qtyBtn {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 7px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition: background 0.12s;
}
.qtyBtn:hover { background: #f3f4f6; }
.qtyBadge {
  min-width: 24px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  color: #1f2937;
}
.removeBtn {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 8px;
  margin: -4px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.removeBtn:hover {
  color: #ef4444;
  background: #fee2e2;
}
@media (max-width: 400px) {
  .cartItem {
    flex-wrap: wrap;
    padding: 12px 2px;
  }
  .cartItemLeft {
    flex: 1 1 100%;
    margin-bottom: 8px;
  }
  .cartItemRight {
    flex: 1 1 100%;
    justify-content: space-between;
  }
  .removeBtn {
    order: -1;
    margin-left: 0;
    margin-right: auto;
    background: #f3f4f6;
    color: #6b7280;
  }
}
.emptyProducts { color: #888; font-size: 14px; padding: 12px 0; text-align: center; }
.closeIcon {
  color: #666;
  font-size: 18px;
  position: absolute;
  top: -20px;
  right: -20px;
  padding: 20px;
  border-radius: 100%;
  background: whitesmoke;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.closeIcon:hover { color: #222; }

/* ── Toast ── */
.addedToast {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  background: rgba(30, 30, 30, 0.92);
  color: #fff;
  padding: 10px 16px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  z-index: 2000;
  font-weight: 600;
  font-size: 14px;
}
.addedToast i { color: #22c55e; }
.toast-pop-enter-active,
.toast-pop-leave-active { transition: all 200ms ease; }
.toast-pop-enter-from,
.toast-pop-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px) scale(0.97);
}
.toast-pop-enter-to,
.toast-pop-leave-from {
  opacity: 1;
  transform: translate(-50%, 0) scale(1);
}

/* ── Product card animations ── */
.productCard.justAdded {
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.35), 0 8px 20px rgba(0, 0, 0, 0.08);
  border-color: #22c55e !important;
  animation: card-pop 240ms ease;
}
.productCard.inCart {
  background: linear-gradient(0deg, rgba(34, 197, 94, 0.08), rgba(34, 197, 94, 0.08)), #fff;
  border: 1px solid rgba(34, 197, 94, 0.35);
}
@keyframes card-pop {
  0% { transform: scale(1); }
  60% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

@media (max-width: 480px) {
  .productsModalBody { max-height: 72vh; }
}

</style>

<style scoped>
/* ── Modal action row (shared by tip-address and order-id modals) ── */
.modalActionsRow {
  display: flex;
  gap: 12px;
  width: 100%;
}
.modalActionsRow .btn-secondary,
.modalActionsRow .btn-secondary-alt {
  flex: 1;
}

/* ── Tip modal header ── */
.tipModalHeader {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.tipModalHeaderContent {
  flex: 1;
}
.tipModalTitle {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: #222;
}
.tipCurrentBase {
  font-size: 14px;
  color: #666;
}

/* ── Segment control (Percentage / Round Up) ── */
.tipModeSelector {
  display: flex;
  gap: 4px;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 4px;
}
.tipModeBtn {
  flex: 1;
  padding: 8px 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.15s ease;
}
.tipModeBtn:hover:not(.tipModeBtn--active) {
  background: rgba(0, 0, 0, 0.05);
  color: #444;
}
.tipModeBtn--active {
  background: #fff;
  color: #222;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}
.tipModeBtn:focus-visible {
  outline: 2px solid #ff9f1a;
  outline-offset: -2px;
}

/* ── Tip preset buttons ── */
.tipOptions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}
.tipBtn {
  min-width: 72px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: linear-gradient(180deg, #f9fafb, #f3f4f6);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  font-size: 17px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.tipBtn:hover {
  background: #ececee;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.tipBtn:focus-visible {
  outline: 2px solid #ff9f1a;
  outline-offset: 2px;
}
.tipBtn:active {
  transform: scale(0.97);
}
.tipBtn--active {
  background: linear-gradient(180deg, #ff9f1a, #ff8a00);
  color: #fff;
  border-color: #eb8d01;
  box-shadow: 0 4px 12px rgba(255, 153, 0, 0.35);
}
.tipBtn--active:hover {
  background: linear-gradient(180deg, #ff8a00, #ff7a00);
  box-shadow: 0 6px 16px rgba(255, 153, 0, 0.5);
}

/* ── Custom amount row ── */
.customTipRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
  padding: 0 2px;
}
.customTipRow--withHint {
  flex-wrap: wrap;
}
.customTipHint {
  width: 100%;
  font-size: 11px;
  color: #888;
  text-align: right;
  margin-top: 4px;
}
.customTipLabel {
  font-size: 14px;
  font-weight: 600;
  color: #444;
}
.customTipInputGroup {
  display: flex;
  align-items: center;
  gap: 8px;
}
.customTipInput {
  width: 110px;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #f7f7f8;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
  outline: none;
}
.customTipInput:focus {
  border-color: rgba(100, 152, 208, 0.5);
  background: #fff;
}
.customTipCurrency {
  font-size: 15px;
  font-weight: 600;
  color: #555;
}

/* ── Round-up helper text ── */
.tipHelp {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 0 0 10px;
}

/* ── Summary card ── */
.tipSummaryCard {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.tipSummaryRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
  color: #444;
}
.tipSummaryRow--discount {
  color: #22a045;
  font-weight: 600;
}
.tipSummaryDivider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 6px 0;
}
.tipSummaryRow--total {
  font-size: 17px;
  font-weight: 700;
  color: #222;
}

/* ── Action buttons ── */
.tipModalActions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tipConfirmBtn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #ff9f1a, #ff8a00);
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(255, 153, 0, 0.35);
  transition: filter 0.15s ease, box-shadow 0.15s ease;
}
.tipConfirmBtn:hover {
  filter: brightness(0.97);
  box-shadow: 0 8px 18px rgba(255, 153, 0, 0.45);
}
.tipSkipBtn {
  background: none;
  border: none;
  color: #888;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  padding: 4px;
  text-decoration: underline;
  transition: color 0.15s;
}
.tipSkipBtn:hover {
  color: #555;
}
</style>
